//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { useConnectedInstagramAccountsMessagesAccessStatusQuery } from '@account-settings/accountSettingsQueries';
import { partitionAccountsByMessagesAccessStatus } from '@account-settings/utils/instagramMessagesAccessStatusUtils';
import { useHasInstagramManageMessagesFeatureAndPermissions } from '@uia/rights/hooks/useHasInstagramManageMessagesFeatureAndPermissions';

export const useInstagramMessagesAccess = () => {
  const {
    hasInstagramManageMessagesFeatureAndPermissions,
    isFetchingInstagramManageMessagesFeatureAndPermissions,
  } = useHasInstagramManageMessagesFeatureAndPermissions();

  const {
    data: messagesAccessStatus,
    isError: isMessagesAccessStatusError,
    isLoading: isMessagesAccessStatusLoading,
  } = useConnectedInstagramAccountsMessagesAccessStatusQuery((data) =>
    partitionAccountsByMessagesAccessStatus(data.status),
  );

  return {
    data: messagesAccessStatus,
    isLoading:
      isFetchingInstagramManageMessagesFeatureAndPermissions ||
      isMessagesAccessStatusLoading,

    // we can safely ignore the errors when the manage messages permsissions are not granted
    // because the manage messages permissions is a pre requisite for getting the messages access status
    isError:
      !isFetchingInstagramManageMessagesFeatureAndPermissions &&
      hasInstagramManageMessagesFeatureAndPermissions &&
      isMessagesAccessStatusError,
  };
};
